export default "__VITE_ASSET__CFnRSVNF__"